import {
    ApiProductSortOption,
    DEFAULT_PRODUCT_SORT_OPTION,
} from '@storefronts/common-types'
import React, { createContext, useContext, useState } from 'react'

interface ProductSortContextType {
    sortOption: ApiProductSortOption
    setSortOption: (option: ApiProductSortOption) => void
}

const ProductSortContext = createContext<ProductSortContextType>({
    sortOption: DEFAULT_PRODUCT_SORT_OPTION,
    setSortOption: () => {},
})

export const ProductSortProvider: React.FC<{
    children: React.ReactNode
    defaultSort?: ApiProductSortOption
}> = ({ children, defaultSort = DEFAULT_PRODUCT_SORT_OPTION }) => {
    const [sortOption, setSortOption] =
        useState<ApiProductSortOption>(defaultSort)

    return (
        <ProductSortContext.Provider value={{ sortOption, setSortOption }}>
            {children}
        </ProductSortContext.Provider>
    )
}

export const useProductSort = () => {
    const context = useContext(ProductSortContext)
    if (!context) {
        throw new Error(
            'useProductSort must be used within a ProductSortProvider',
        )
    }
    return context
}
